/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CashbackEdit_lists$ref: FragmentReference;
declare export opaque type CashbackEdit_lists$fragmentType: CashbackEdit_lists$ref;
export type CashbackEdit_lists = {|
  +stores: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>
  |},
  +$refType: CashbackEdit_lists$ref,
|};
export type CashbackEdit_lists$data = CashbackEdit_lists;
export type CashbackEdit_lists$key = {
  +$data?: CashbackEdit_lists$data,
  +$fragmentRefs: CashbackEdit_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CashbackEdit_lists",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "active",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "StoreConnection",
      "kind": "LinkedField",
      "name": "stores",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Store",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "stores(active:false,first:1000)"
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '4f0ed70c08d614648153d9f010a9a34c';

module.exports = node;
